import { useNavigate } from "react-router-dom";
import { usePagedData } from "@/hooks/usePagedData";
import { PageHeader } from "@/components/common/PageHeader";
import { DataTable } from "@/components/common/DataTable";
import { KpiCard } from "@/components/common/KpiCard";
import { Loader } from "@/components/common/Loader";
import { Pager, SearchInput } from "@/components/common/Pager";
import { eur } from "@/lib/format";
import { Users } from "lucide-react";

export default function Customers() {
  const { items, stats, total, pages, page, setPage, q, setQ, loading, pageSize } = usePagedData("/customers");
  const navigate = useNavigate();

  const limit = stats.credit_limit || 0;
  const used = stats.credit_used || 0;

  const columns = [
    { key: "customer_code", label: "BP / Sold-To", render: (r) => <span className="font-mono text-xs text-[#7c3aed]">{r.customer_code}</span> },
    { key: "name", label: "Name", render: (r) => (
      <div><div className="text-[#32363a]">{r.name}</div><div className="text-[10px] text-[#6a6d70]">{r.address?.city}, {r.country}</div></div>) },
    { key: "region", label: "Region", render: (r) => <span className="font-mono text-[10px] text-[#6a6d70]">{r.region}</span> },
    { key: "customer_group", label: "Group", render: (r) => <span className="font-mono text-xs text-[#6a6d70]">{r.customer_group}</span> },
    { key: "payment_terms", label: "Terms", render: (r) => <span className="font-mono text-xs">{r.payment_terms}</span> },
    { key: "credit", label: "Credit Utilisation", render: (r) => {
      const pct = r.credit_limit ? Math.min(100, Math.round(((r.credit_used || 0) / r.credit_limit) * 100)) : 0;
      return (<div className="w-36"><div className="flex justify-between text-[10px] text-[#6a6d70]"><span>{eur(r.credit_used || 0)}</span><span>{pct}%</span></div>
        <div className="mt-1 h-1.5 rounded bg-[#eef1f5]"><div className={`h-1.5 rounded ${pct > 80 ? "bg-[#bb0000]" : "bg-[#7c3aed]"}`} style={{ width: `${pct}%` }} /></div>
        <div className="mt-0.5 text-[10px] text-[#89919a]">limit {eur(r.credit_limit)}</div></div>); } },
  ];

  return (
    <div>
      <PageHeader title="Business Partners" subtitle="Real Euro Packaging customer master with partner functions (Sold-To, Ship-To, Bill-To, Payer), sales area and credit management." icon={Users} accent="#7c3aed" />
      <div className="mb-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KpiCard label="Customers" value={total.toLocaleString()} accent="#7c3aed" />
        <KpiCard label="Total Credit Limit" value={eur(limit)} accent="#7c3aed" />
        <KpiCard label="Credit Exposure" value={eur(used)} accent="#e9730c" />
        <KpiCard label="Available" value={eur(limit - used)} accent="#107e3e" />
      </div>
      <div className="mb-3"><SearchInput testId="customers-search" value={q} onChange={setQ} placeholder="Search customers by name, code, city…" /></div>
      {loading && items.length === 0 ? <Loader /> : (
        <DataTable testId="customers-table" columns={columns} rows={items} onRowClick={(r) => navigate(`/customers/${r.id}`)} />
      )}
      <Pager testId="customers-pager" page={page} pages={pages} total={total} pageSize={pageSize} onPage={setPage} />
    </div>
  );
}
